import { FC } from 'react'
import {
  OrganizationJsonLd,
  WebPageJsonLd
} from '@lifedot/components/StructuredData'
import { markup } from '@lifedot/utils'
import { graphql } from 'relay-runtime'
import { useFragment } from 'react-relay/hooks'
import { PostStructuredData_post$key } from './__generated__/PostStructuredData_post.graphql'
import { useArticle } from './dependencies'
import { router, urlify } from '@lifedot/router'

interface PostStructuredDataProps {
  post: PostStructuredData_post$key | null
  showArticle?: boolean
}

export const PostStructuredData: FC<PostStructuredDataProps> = ({
  post,
  showArticle = false
}) => {
  const data = useFragment(fragment, post)
  const article = useArticle(data, showArticle)

  return (
    <>
      <OrganizationJsonLd data-cy="structured-data-organization" />
      <WebPageJsonLd
        description={data?.meta_description ?? ''}
        url={urlify(router.post(data?.slug ?? ''))}
        dateModified={data?.modified_at ?? ''}
        data-cy="structured-data-web-page"
      />
      {article && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={markup(article)}
          data-cy="structured-data-article"
        />
      )}
    </>
  )
}

const fragment = graphql`
  fragment PostStructuredData_post on Post {
    slug
    h1
    image {
      url
    }
    meta_description
    published_at
    modified_at
  }
`
